import { render, staticRenderFns } from "./HotRecommend.vue?vue&type=template&id=42203354&scoped=true"
import script from "./HotRecommend.vue?vue&type=script&lang=js"
export * from "./HotRecommend.vue?vue&type=script&lang=js"
import style0 from "./HotRecommend.vue?vue&type=style&index=0&id=42203354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42203354",
  null
  
)

export default component.exports